'use client';

import { lazy, useEffect } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { APP_LANGUAGE_COOKIE_NAME, ENABLE_DEV_TOOLS } from '../../configs/app.config';
import { QUERY_CACHE } from '../../configs/services/services.config';

import type { IComponentWithReactChildren } from '../../types/components/components.type';

// devTools loaders
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then((m) => ({
    default: m.ReactQueryDevtools,
  })),
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...QUERY_CACHE,
    },
  },
});

export const ClientContext = ({
  locale,
  children,
}: { locale: string } & IComponentWithReactChildren) => {
  useEffect(() => {
    localStorage.setItem(APP_LANGUAGE_COOKIE_NAME, locale);
  }, [locale]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ENABLE_DEV_TOOLS && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
};
